<!-- Admin / bare mode: standard .form-control, no floating label.
     Meant to sit inside <app-form-row>, which supplies the static label. -->
<ng-container *ngIf="control && bare">
  <input
    *ngIf="!multiline"
    #bareInput
    [id]="inputId"
    [type]="inputType"
    [attr.inputmode]="inputMode"
    [attr.min]="min"
    [attr.max]="max"
    [attr.data-testid]="testId"
    [class.form-control]="!plain"
    [ngClass]="cssClass"
    [class.is-invalid]="showError"
    [autocomplete]="autocomplete"
    [maxLength]="maxLength"
    [formControl]="control"
    (keyup)="onKeyup($event)"
    (keydown)="keydownEvent.emit($event)"
    (change)="onChange($event)"
    (input)="onInput($event)"
    (focus)="focusEvent.emit($event)"
    (focusout)="onFocusout($event)"
    (blur)="onBlur($event)"
    [trim]="trim"
    [placeholder]="placeholder"
    [attr.disabled]="isDisabled ? true : null"
    [readonly]="readonly"
  />
  <textarea
    *ngIf="multiline"
    [id]="inputId"
    [attr.data-testid]="testId"
    [class.form-control]="!plain"
    [ngClass]="cssClass"
    [class.is-invalid]="showError"
    [autocomplete]="autocomplete"
    [maxLength]="maxLength"
    [rows]="rows"
    [formControl]="control"
    (keyup)="onKeyup($event)"
    (change)="onChange($event)"
    (input)="onInput($event)"
    (focusout)="onFocusout($event)"
    (blur)="onBlur($event)"
    [trim]="trim"
    [placeholder]="placeholder"
    [attr.disabled]="isDisabled ? true : null"
    [readonly]="readonly"
  ></textarea>
  <div
    class="invalid-feedback d-block"
    [attr.data-testid]="errorTestId"
    *ngIf="showError"
  >
    <span *ngIf="errorText?.trim()">{{ errorText }}</span>
    <span *ngIf="!errorText?.trim()">{{
      errorMessageKey | translate: errorMessageParams
    }}</span>
  </div>
  <app-explanation *ngIf="helpText" [text]="helpText"></app-explanation>
</ng-container>

<!-- Standalone bare mode: no FormControl — parent drives [value] and reads
     events (mirrors the checkbox/toggle standalone convention). -->
<input
  *ngIf="!control && bare && !multiline"
  #bareInput
  [id]="inputId"
  [type]="inputType"
  [attr.inputmode]="inputMode"
  [attr.min]="min"
  [attr.max]="max"
  [attr.data-testid]="testId"
  [class.form-control]="!plain"
  [ngClass]="cssClass"
  [class.is-invalid]="isInvalid"
  [autocomplete]="autocomplete"
  [maxLength]="maxLength"
  [value]="value ?? ''"
  (keyup)="onKeyup($event)"
  (keydown)="keydownEvent.emit($event)"
  (change)="onChange($event)"
  (input)="onInput($event)"
  (focus)="focusEvent.emit($event)"
  (focusout)="onFocusout($event)"
  (blur)="onBlur($event)"
  [placeholder]="placeholder"
  [attr.disabled]="isDisabled ? true : null"
  [readonly]="readonly"
/>

<!-- Floating-label mode (default; customer UI) -->
<div class="input-group mb-4" *ngIf="control && !bare">
  <input
    [id]="inputId"
    [type]="inputType"
    class="form-control"
    [ngClass]="{
      'is-invalid': isInvalid,
      populated: hasValue,
    }"
    [autocomplete]="autocomplete"
    [maxLength]="maxLength"
    [formControl]="control"
    (keyup)="onKeyup($event)"
    (change)="onChange($event)"
    (focusout)="onFocusout($event)"
    (blur)="onBlur($event)"
    [trim]="trim"
    [placeholder]="placeholder"
    [attr.disabled]="isDisabled ? true : null"
  />
  <label [for]="inputId" class="placeholder font-size-primary">
    {{ label }}
    <ng-container *ngIf="required">*</ng-container>
    <ng-container *ngIf="!required && optionalTag">{{
      'public.global.optional' | translate
    }}</ng-container>
  </label>
  <div
    class="invalid-feedback font-size-secondary"
    [attr.data-testid]="errorTestId"
    *ngIf="isInvalid && errorText?.trim()"
  >
    <span>{{ errorText }}</span>
  </div>
</div>
